import { ExerciseBlock } from '@/types/workout';

export interface ExerciseRow {
  id: string;
  name: string;
  sets: string; // "-" for time-based, or "3" for reps-based
  repsOrTime: string; // "30s" for time-based, or "10 reps" for reps-based
  rest: string; // "10s" format
  order: number;
  phase?: 'warmup' | 'main' | 'cooldown';
  supersetGroupId?: string;
  supersetGroupIndex?: number; // Index for determining letter (A=0, B=1, C=2, etc.)
}

/**
 * Normalizes ExerciseBlock[] to table row format for compact view
 * Calculates superset group indices matching WorkoutOverview logic
 */
export function normalizeExercisesToRows(exercises: ExerciseBlock[]): ExerciseRow[] {
  // Calculate superset group indices (matching WorkoutOverview logic)
  const supersetGroups = new Map<string, number>();
  let groupIndex = 0;
  
  exercises.forEach((exercise) => {
    if (exercise.superset_group_id && !supersetGroups.has(exercise.superset_group_id)) {
      supersetGroups.set(exercise.superset_group_id, groupIndex++);
    }
  });

  return exercises.map((exercise) => {
    const { target, rest_seconds } = exercise;

    let sets: string;
    let repsOrTime: string;

    if (target.mode === 'time') {
      // Time-based exercises: Sets = "-", Reps/Time = duration
      sets = '-';
      repsOrTime = `${target.duration_seconds || 0}s`;
    } else {
      // Reps-based exercises: Sets = number or "-", Reps/Time = reps
      sets = target.sets ? String(target.sets) : '-';
      repsOrTime = `${target.reps || 0} reps`;
    }

    const supersetGroupIndex = exercise.superset_group_id
      ? supersetGroups.get(exercise.superset_group_id)
      : undefined;

    return {
      id: exercise.id,
      name: exercise.name,
      sets,
      repsOrTime,
      rest: `${rest_seconds}s`,
      order: exercise.order,
      phase: exercise.phase,
      supersetGroupId: exercise.superset_group_id,
      supersetGroupIndex,
    };
  });
}

